import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ExistingReportDailySummaryTableComponent } from '@app/areas/reports/components/existing-report-daily-summary-table/existing-report-daily-summary-table.component';
import { ExistingBatchReportComponent } from '../existing-batch-report/existing-batch-report.component';
import { CommonModule, NgSwitchCase } from '@angular/common';
import { PortalTheme } from '@app/@shared/models';
import { ApplicationProfileService } from '@app/@shared/services/application-profile.service';
import { ExistingSdkBatchReportComponent } from '../existing-sdk-batch-report/existing-sdk-batch-report.component';

@Component({
  selector: 'app-existing-report',
  standalone: true,
  imports: [
    ExistingReportDailySummaryTableComponent,
    ExistingBatchReportComponent,
    CommonModule,
    NgSwitchCase,
    ExistingBatchReportComponent,
    ExistingSdkBatchReportComponent,
  ],
  templateUrl: './existing-report.component.html',
  styleUrl: './existing-report.component.scss',
})
export class ExistingReportComponent implements OnInit {
  private readonly route = inject(ActivatedRoute);
  public reportUrl: string | undefined;

  protected theme!: PortalTheme;
  private readonly applicationProfileService = inject(ApplicationProfileService);

  public ngOnInit(): void {
    this.reportUrl = this.route.snapshot.url.map((segment) => segment.path).pop();

    this.applicationProfileService.applicationProfile$.subscribe((profile) => {
      this.theme = profile.PortalTheme.Theme;
    });
  }
}
